import { Drawer, Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MapIconSelector from './MapIconSelector';
import { StationType } from '../schema';
import { db } from '../instant';
import { useContext } from 'react';
import { MapContext } from '../context';
import { EVENT_BOTTOM_NAV_HEIGHT } from 'src/spacing';
import { useMobileKeyboardOpen } from 'src/utils';

interface Props {
    open: boolean;
    todo: boolean;
    currentStation: StationType | null;
    setCurrentStation: (station: StationType | null) => void;
}

export default function MapIconDrawer(props: Props) {
    const mapContext = useContext(MapContext);
    const { toggleEditMode } = mapContext;
    const isKeyboardOpen = useMobileKeyboardOpen();

    const helpText =
        props.currentStation === null ? 'Select a station to add to the map' : 'Click on the map to place the selected station';

    const { isLoading, error, data } = db.useQuery({ stationTypes: {} });

    if (isLoading) {
        console.log('loading stations...');
        return <></>;
    }
    if (error) {
        console.error('error loading stations: ', error);
        return <div>Error fetching icons: {error.message}</div>;
    }

    let { stationTypes } = data;
    stationTypes.sort((a, b) => (a.order as number) - (b.order as number));

    console.log('got stations ', stationTypes);

    const content = (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Typography sx={{ margin: 2, marginBottom: 0, flex: 1 }}>{helpText}</Typography>
                {!props.todo && (
                    <IconButton onClick={toggleEditMode} sx={{ position: 'absolute', right: 8 }}>
                        <CloseIcon />
                    </IconButton>
                )}
            </Box>
            <MapIconSelector stations={stationTypes} currentStation={props.currentStation} setCurrentStation={props.setCurrentStation} />
        </>
    );

    if (props.todo) {
        return content;
    }

    return (
        <Drawer
            id="map-icon-drawer"
            anchor="bottom"
            variant="persistent"
            open={props.open}
            sx={{ zIndex: 1000 }}
            PaperProps={{
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    bottom: isKeyboardOpen ? 0 : EVENT_BOTTOM_NAV_HEIGHT,
                    transition: 'bottom 0.3s ease-in-out',
                },
            }}
        >
            {content}
        </Drawer>
    );
}
